"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REAL_ORIGINS = exports.ORIGINS = void 0;
exports.ORIGINS = {
    comissoes_xp_api: 'comissoes_xp_api',
    comissoes_xp: 'comissoes_xp',
    comissoes_xp_hub: 'comissoes_xp_hub',
    new_previdencia_xp: 'new_previdencia_xp',
    new_co_corretagem_xp: 'new_co_corretagem_xp',
    new_banco_xp: 'new_banco_xp',
    new_cambio_xp: 'new_cambio_xp',
    new_offshore_xp: 'new_offshore_xp',
    offshore_xp: 'offshore_xp',
    investimento_global_xp: 'investimento_global_xp',
    xpeed_xp: 'xpeed_xp',
    dm10: 'dm10',
    xtage_xp: 'xtage_xp',
    xpvp_xp: 'xpvp_xp',
    previdencia_xp: 'previdencia_xp',
    co_corretagem_xp: 'co_corretagem_xp',
    banco_xp: 'banco_xp',
    cambio_xp: 'cambio_xp',
    positivador_xp: 'positivador_xp',
    base_btg: 'base_btg',
    comissoes_guide: 'comissoes_guide',
    globus: 'globus',
    mongeral: 'mongeral',
    mongeral_vg: 'mongeral_vg',
    prudential: 'prudential',
    icatu: 'icatu',
    icatu_pj: 'icatu_pj',
    sulamerica: 'sulamerica',
    mapfre: 'mapfre',
    ourinvest: 'ourinvest',
    warren: 'warren',
    unimed: 'unimed',
    zurich: 'zurich',
    porto_seguro: 'porto_seguro',
    comissoes_btg: 'comissoes_btg',
    previdencia_btg: 'previdencia_btg',
    cambio_btg: 'cambio_btg',
    icatu_btg: 'icatu_btg',
    previa_btg: 'previa_btg',
    comissoes_genial: 'comissoes_genial',
    azimut: 'azimut',
    superbase_azimut: 'superbase_azimut',
    orama: 'orama',
    terra: 'terra',
    modal: 'modal',
    modal_mensal: 'modal_mensal',
    investors_trust: 'investors_trust',
    avenue: 'avenue',
    avenue_estrangeira: 'avenue_estrangeira',
    bnk_protect: 'bnk_protect',
    bnk_exchange: 'bnk_exchange',
    omint: 'omint',
    ticket_pat: 'ticket_pat',
    prudential_btg: 'prudential_btg',
    btg_corban: 'btg_corban',
    rede_dor: 'rede_dor',
    crediclass: 'crediclass',
    cambio_master: 'cambio_master',
    splitc: 'splitc',
    treviso_exchange: 'treviso_exchange',
    cashme_corporate: 'cashme_corporate',
    managed_assets: 'managed_assets',
    cashback_assets_btg: 'cashback_assets_btg',
    btg_offshore: 'btg_offshore',
    splitc_metricas: 'splitc_metricas',
    splitc_aum: 'splitc_aum',
    financiamento_imobiliario_xp: 'financiamento_imobiliario_xp',
    energia_xp: 'energia_xp',
    argo: 'argo',
    safra_invest: 'safra_invest',
    safra_ativos: 'safra_ativos',
    studio_xp: 'studio_xp',
    new_btg_previdencia: 'new_btg_previdencia',
    new_btg_offshore: 'new_btg_offshore',
};
exports.REAL_ORIGINS = {
    new_previdencia_xp: exports.ORIGINS.previdencia_xp,
    new_co_corretagem_xp: exports.ORIGINS.co_corretagem_xp,
    new_banco_xp: exports.ORIGINS.banco_xp,
    new_cambio_xp: exports.ORIGINS.cambio_xp,
    new_offshore_xp: exports.ORIGINS.offshore_xp,
};
